import { browseCardBox } from '@/components/courses/courses.styles';
import { CreateContentPlusIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledCreateNewContentCard = styled.button`
  ${browseCardBox}
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--xsmall-padding);
  background-color: var(--beige-main);
  padding: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--green-main);
    outline-offset: var(--xxxsmall-padding);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  color: var(--gray-medium-dark);
`;

const CreateNewContentLabel = styled.span`
  font-size: var(--medium-font-size);
  font-weight: 600;
  color: var(--black-main);
`;

type CreateNewContentCardProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const CreateNewContentCard: React.FC<CreateNewContentCardProps> = ({
  onClick,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <StyledCreateNewContentCard
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      <CreateContentPlusIcon />
      <CreateNewContentLabel>
        {t('content.browse.createNewContent')}
      </CreateNewContentLabel>
    </StyledCreateNewContentCard>
  );
};
